import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { UserPlus, X, Wallet, ExternalLink } from 'lucide-react';

export const CompanionsTab = ({
  companions,
  setShowInviteDialog,
  handleRemoveCompanion,
  itineraryId,
}) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="font-serif text-xl text-white drop-shadow-md">Travel Companions</h3>
        <Button onClick={() => setShowInviteDialog(true)} className="bg-gold hover:bg-gold-light text-ocean rounded-full" data-testid="invite-companion-btn">
          <UserPlus className="w-4 h-4 mr-2" /> Invite Companion
        </Button>
      </div>
      {companions.length === 0 ? (
        <Card className="bg-white/95 backdrop-blur-xl border-white/30 shadow-xl">
          <CardContent className="p-12 text-center">
            <UserPlus className="w-12 h-12 text-ocean/30 mx-auto mb-4" />
            <p className="text-ocean/50 mb-2">No companions yet</p>
            <p className="text-ocean/40 text-sm">Invite friends or family to join your trip!</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {companions.map((comp) => (
            <Card key={comp.id} className="bg-white/95 backdrop-blur-xl border-white/30 shadow-xl">
              <CardContent className="p-5 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-ocean/10 rounded-full flex items-center justify-center text-ocean font-bold">
                    {(comp.name || comp.email)[0].toUpperCase()}
                  </div>
                  <div>
                    {comp.name && <p className="font-medium text-ocean">{comp.name}</p>}
                    <p className="text-sm text-ocean/60">{comp.email}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`px-2 py-0.5 rounded-full text-xs ${comp.status === 'accepted' ? 'bg-green-100 text-green-700' : comp.status === 'declined' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
                    {comp.status}
                  </span>
                  <Button variant="ghost" size="icon" onClick={() => handleRemoveCompanion(comp.id)}
                    className="text-red-400 hover:text-red-600 w-8 h-8" data-testid={`remove-companion-${comp.id}`}>
                    <X className="w-4 h-4" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}

      <Card className="bg-white/95 backdrop-blur-xl border-white/30 shadow-xl hover:shadow-2xl transition-all cursor-pointer"
        onClick={() => navigate(`/itinerary/${itineraryId}/budget`)} data-testid="budget-tracker-link">
        <CardContent className="p-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-ocean rounded-xl flex items-center justify-center"><Wallet className="w-6 h-6 text-white" /></div>
            <div>
              <h4 className="font-semibold text-ocean text-lg">Budget Tracker</h4>
              <p className="text-ocean/70 text-sm">Track your trip expenses and manage your budget</p>
            </div>
          </div>
          <ExternalLink className="w-5 h-5 text-ocean" />
        </CardContent>
      </Card>
    </div>
  );
};
